
// export const sanitizeHTML = (html: string) => {
//   if (!html) return "";
//   return html
//     .replace(/<script.*?>.*?<\/script>/gi, "")
//     .replace(/<style.*?>.*?<\/style>/gi, "")
//     .replace(/on\w+=".*?"/g, "") // removes onclick, onerror etc.
//     .replace(/javascript:/gi, "").replace(/<[^>]*>/g, "");
// };

// const stripHtml = (html: string = "") => {
//   const decoded = html
//     .replace(/&lt;/g, "<")
//     .replace(/&gt;/g, ">")
//     .replace(/&amp;/g, "&");
//   return decoded.replace(/<[^>]*>/g, "");
// };

export const decodeHTML = (html: string) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};


export const capitalizeFirst = (str = "") => str.charAt(0).toUpperCase() + str.slice(1);